import { css } from "styled-components"

import media from "styles/media"

export const fonts = {
  skeleton: "font-family: 'Plain Skeleton';",
  hairline: "font-family: 'Plain Hairline';",
  ultraThin: "font-family: 'Plain Ultrathin';",
  ultraLight: "font-family: 'Plain Ultralight';",
  thin: "font-family: 'Plain Thin';",
  light: "font-family: 'Plain Light';",
  italic: "font-family: 'Light Italic';",
  regular: "font-family: 'Plain';",
  medium: "font-family: 'Plain Medium",
  bold: "font-family: 'Plain Bold';",
  extraBold: "font-family: 'Plain ExtraBold';",
  black: "font-family: 'Plain Black';",
  super: "font-family: 'Plain Super';",
} as const

const text = {
  h1: css`
    ${fonts.ultraThin};
    font-style: normal;
    font-weight: 100;
    font-size: 192px;
    line-height: 100%;
    letter-spacing: -0.04em;
    ${media.desktop} {
      font-size: 11.566vw;
    }
    ${media.tablet} {
      font-size: 18.75vw;
    }
    ${media.mobile} {
      font-size: 51.2vw;
    }
  `,
  h1Mobile: css`
    ${fonts.ultraLight};
    font-style: normal;
    font-weight: 100;
    line-height: 100%;
    letter-spacing: -0.04em;
    ${media.desktop} {
    }
    ${media.tablet} {
    }
    ${media.mobile} {
      font-size: 9.6vw;
      line-height: 115%;
      letter-spacing: -0.02em;
    }
  `,
  h1MobileNew: css`
  ${fonts.ultraThin};
  font-style: normal;
  font-weight: 100;
  font-size: 192px;
  line-height: 100%;
  letter-spacing: -0.04em;
  ${media.desktop} {
    font-size: 11.566vw;
  }
  ${media.tablet} {
    font-size: 18.75vw;
  }
  ${media.mobile} {
    font-size: 51.2vw;
  }
`,
  h2: css`
    ${fonts.ultraThin}
    font-style: normal;
    font-weight: 100;
    font-size: 96px;
    line-height: 100%;
    letter-spacing: -0.02em;
    ${media.desktop} {
      font-size: 5.783vw;
    }
    ${media.tablet} {
      font-size: 9.375vw;
    }
    ${media.mobile} {
      font-size: 25.6vw;
    }
  `,
  h2Mobile: css`
    ${fonts.ultraThin}
    font-style: normal;
    font-weight: 100;
    font-size: 96px;
    line-height: 100%;
    letter-spacing: -0.02em;
    ${media.desktop} {
      font-size: 5.783vw;
    }
    ${media.tablet} {
      font-size: 9.375vw;
    }
    ${media.mobile} {
      font-size: 30.6vw;
    }
  `,
  h3: css`
    ${fonts.ultraThin}
    font-style: normal;
    font-weight: 100;
    font-size: 64px;
    line-height: 110%;
    letter-spacing: -0.02em;
    ${media.desktop} {
      font-size: 3.855vw;
    }
    ${media.tablet} {
      font-size: 6.25vw;
    }
    ${media.mobile} {
      font-size: 17.067vw;
    }
  `,
  h4: css`
    ${fonts.ultraThin}
    font-style: normal;
    font-weight: 100;
    font-size: 48px;
    line-height: 120%;
    letter-spacing: -0.01em;
    ${media.desktop} {
      font-size: 2.892vw;
    }
    ${media.tablet} {
      font-size: 4.688vw;
    }
    ${media.mobile} {
      font-size: 12.8vw;
    }
  `,
  h5: css`
    ${fonts.ultraLight}
    font-style: normal;
    font-weight: 100;
    font-size: 32px;
    line-height: 130%;
    letter-spacing: -0.02em;

    ${media.desktop} {
      font-size: 1.928vw;
    }
    ${media.tablet} {
      font-size: 3.125vw;
    }
    ${media.mobile} {
      font-size: 8.533vw;
    }
  `,
  h6: css`
    ${fonts.ultraLight}
    font-style: normal;
    font-weight: 100;
    font-size: 24px;
    line-height: 130%;
    letter-spacing: -0.02em;
    ${media.desktop} {
      font-size: 1.446vw;
    }
    ${media.tablet} {
      font-size: 2.344vw;
    }
    ${media.mobile} {
      font-size: 6.4vw;
    }
  `,

  bodyL: css`
    ${fonts.thin}
    font-style: normal;
    font-weight: 100;
    font-size: 24px;
    line-height: 160%;

    ${media.desktop} {
      font-size: 1.446vw;
    }
    ${media.tablet} {
      font-size: 2.344vw;
    }
    ${media.mobile} {
      font-size: 6.4vw;
    }
  `,
  bodyR: css`
    ${fonts.light}
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 180%;
    ${media.desktop} {
      font-size: 0.964vw;
    }
    ${media.tablet} {
      font-size: 1.563vw;
    }
    ${media.mobile} {
      font-size: 4.267vw;
    }
  `,
  bodyRBold: css`
    ${fonts.bold}
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 180%;
    ${media.desktop} {
      font-size: 0.964vw;
    }
    ${media.tablet} {
      font-size: 1.563vw;
    }
    ${media.mobile} {
      font-size: 4.267vw;
    }
  `,
  bodyRItalic: css`
    ${fonts.italic}
    font-style: italic;
    font-weight: 300;
    font-size: 16px;
    line-height: 180%;
    ${media.desktop} {
      font-size: 0.964vw;
    }
    ${media.tablet} {
      font-size: 1.563vw;
    }
    ${media.mobile} {
      font-size: 4.267vw;
    }
  `,
  bodyS: css`
    ${fonts.light}
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 150%;
    ${media.desktop} {
      font-size: 0.843vw;
    }
    ${media.tablet} {
      font-size: 1.367vw;
    }
    ${media.mobile} {
      font-size: 3.733vw;
    }
  `,
  bodyXS: css`
    ${fonts.light}
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 150%;
    ${media.desktop} {
      font-size: 0.723vw;
    }
    ${media.tablet} {
      font-size: 1.172vw;
    }
    ${media.mobile} {
      font-size: 3.2vw;
    }
  `,
  bodyXXS: css`
    ${fonts.light}
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
    line-height: 140%;
    ${media.desktop} {
      font-size: 0.602vw;
    }
    ${media.tablet} {
      font-size: 0.977vw;
    }
    ${media.mobile} {
      font-size: 2.667vw;
    }
  `,
  bodyXXXS: css`
    font-family: "Plain Light";
    font-style: normal;
    line-height: 140%;
    font-weight: 300;

    ${media.fullWidth} {
      font-size: 8px;
    }
    ${media.desktop} {
      font-size: 0.482vw;
    }
    ${media.tablet} {
      font-size: 0.781vw;
    }

    ${media.mobile} {
      font-size: 2.133vw;
    }
  `,

  buttonL: css`
    ${fonts.regular}
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 130%;
    ${media.desktop} {
      font-size: 1.084vw;
    }
    ${media.tablet} {
      font-size: 1.758vw;
    }
    ${media.mobile} {
      font-size: 4.8vw;
    }
  `,
  buttonR: css`
    ${fonts.regular}
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 130%;
    ${media.desktop} {
      font-size: 0.964vw;
    }
    ${media.tablet} {
      font-size: 1.563vw;
    }
    ${media.mobile} {
      font-size: 4.267vw;
    }
  `,
  buttonS: css`
    ${fonts.regular}
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    ${media.desktop} {
      font-size: 0.964vw;
    }
    ${media.tablet} {
      font-size: 1.563vw;
    }
    ${media.mobile} {
      font-size: 3.733vw;
    }
  `,
  captionKicker: css`
    ${fonts.regular}
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 120%;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    ${media.desktop} {
      font-size: 0.723vw;
    }
    ${media.tablet} {
      font-size: 1.172vw;
    }
    ${media.mobile} {
      font-size: 3.2vw;
    }
  `,
  largeStat: css`
    ${fonts.ultraThin}
    font-style: normal;
    font-weight: 270;
    font-size: 144px;
    line-height: 100%;
    letter-spacing: -0.04em;

    ${media.desktop} {
      font-size: 8.67vw;
    }
    ${media.tablet} {
      font-size: 14.06vw;
    }
    ${media.mobile} {
      font-size: 38.4vw;
    }
  `,
  stat2: css`
    ${fonts.ultraThin};
    font-style: normal;
    font-weight: 270;
    line-height: 110%;
    letter-spacing: -0.02em;

    ${media.fullWidth} {
      font-size: 80px;
    }

    ${media.desktop} {
      font-size: 4.82vw;
    }

    ${media.tablet} {
      font-size: 7.81vw;
    }

    ${media.mobile} {
      font-size: 21.33vw;
    }
  `,
} as const

export const strokeText = css`
  -webkit-background-clip: text;
  -moz-background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  background-size: 100%;
  background-clip: text;
  -webkit-text-stroke-width: 0.07vw;
`

export const strokeTextTransparent = css`
  -webkit-background-clip: text;
  -moz-background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  background-size: 100%;
  background-clip: text;
  -webkit-text-stroke-width: 0.07vw;
`

export const transparentText = css`
  -webkit-background-clip: text;
  -moz-background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  background-size: 100%;
  background-clip: text;
`

export default text
